import { LoadingShim } from "@narmi/design_system";
import { entities } from "byzantine";
import { memo } from "react";
import { LegacyNafUrl } from "../../../types";
import { isAppItem, isLinkItem } from "../utils";
import LinkItem from "./linkItem.component";
import AppItem from "./appItem.component";
import { Bootstrap } from "../topMenu.bootstrap";

type Props = {
  institution?: API.Institution;
  legacyNafUrls: LegacyNafUrl[];
};

const NAFItem = ({ institution, legacyNafUrls }: Props) => {
  const listOfNafItems: {
    [nafName: string]: API.AppMenuItem | API.LinkMenuItem;
  } = entities.institution.useNAFItems();
  institution?.apps?.forEach((app) => {
    listOfNafItems[app.name] = { app };
  });

  legacyNafUrls?.forEach((link) => {
    listOfNafItems[link.title] = {
      url: link.url,
      openNewTab: link.open_new_tab,
    };
  });

  const { loading } = Bootstrap.useBootstrap();

  return (
    <LoadingShim isLoading={loading}>
      {Object.entries(listOfNafItems).map(([nafName, nafItemProps]) => {
        if (isLinkItem(nafItemProps)) {
          return (
            <LinkItem
              item={{ name: nafName, itemProps: nafItemProps }}
              key={nafName}
            />
          );
        }
        if (isAppItem(nafItemProps)) {
          return (
            <AppItem
              item={{ name: nafName, itemProps: nafItemProps }}
              key={nafName}
            />
          );
        }

        return null;
      })}
    </LoadingShim>
  );
};

export default memo(NAFItem);
